export function addMedthodsClassesFromList(list, methods, cls) {
  list.forEach(el => {
    el.classList[methods](cls);
  });
}
export function filterItemsByDataValue(list, specialData, specialDataValue, cls, method = 'remove') {
  list.forEach(el => {
    if (el.getAttribute(specialData) === specialDataValue) {
      el.classList[method](cls);
    }
  });
}